import { render, staticRenderFns } from "./MemberCommunicationDetails.vue?vue&type=template&id=0f6dac28"
import script from "./MemberCommunicationDetails.vue?vue&type=script&lang=js"
export * from "./MemberCommunicationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports